import { Component, ViewChild } from '@angular/core';

import { BsModalComponent } from 'ng2-bs3-modal';

import { DashboardConst, Product } from '../../models/index';
import * as _ from 'lodash';
import { BarcodeGenerationSvc } from '../../services';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
@Component({
  selector: 'barcode-modal',
  styleUrls: ['./barcode-modal.less'],
  template: `
<div class="BarcodeModal">
    <bs-modal class="barcodeModal" [keyboard]="false" [backdrop]="'static'"
           [size]="'lg'" #barcodeModal>
        <form (ngSubmit)="submitForm()" #formBarcode="ngForm" ngNativeValidate>
            <bs-modal-header [showDismiss]="true">
                <div class="modal-title">Créer le code-barres</div>
                <ul class="barcodeModal-nav">
                    <li *ngFor="let category of categories"
                        class="barcodeModal-nav-item"
                        [ngClass]="{'active': category.id === activeCategory.id}">

                        <button type="button" (click)="changeCategory(category)">{{category.libelle}}</button>
                    </li>
                </ul>
            </bs-modal-header>
            <bs-modal-body>

                <!-- Image form-->
                <div class="container-fluid">
                    <barcode-modal-form-img *ngIf="activeCategory.id === 0" [(codeWidth)]="codeWidth" [imgPreviewUrl]="imgPreviewUrl"></barcode-modal-form-img>
                    <barcode-modal-form-vecto *ngIf="activeCategory.id === 1" [(format)]="activeCategory.format"></barcode-modal-form-vecto>
                </div>
            </bs-modal-body>
            <bs-modal-footer [showDefaultButtons]="false">
                <button type="submit" class="barcodeModal-submitButton">
                    <img src="assets/icons/generateCodeWhite.svg" />Télécharger le code-barres
                </button>
            </bs-modal-footer>
        </form>
    </bs-modal>
</div>
`
})
export class BarcodeModal {
  @ViewChild('barcodeModal', {static: true})
  public modal: BsModalComponent;
  @ViewChild('formBarcode', {static: true}) public form: any;
  public constants = DashboardConst;
  public categories = [
    {id: 0, libelle: this.constants.generateForm.categoriesLibelles.img, format: 'png'},
    {id: 1, libelle: this.constants.generateForm.categoriesLibelles.vecto, format: 'eps'}
  ];
  public activeCategory = this.categories[0];
  public codeWidth: number = 40;
  public imgPreviewUrl: SafeUrl;
  public product: Product;

  constructor(private barcodeGenerationSvc: BarcodeGenerationSvc, private sanitizer: DomSanitizer) { }

  public changeCategory(category: any) {
    this.activeCategory = category;
  }

  public openModal(product: Product) {
    this.product = product;
    this.barcodeGenerationSvc.downloadBarCode(product.gtin, this.activeCategory.format, this.codeWidth).subscribe(async data => {

      const blob = typeof data === 'string'
        ? new Blob([data], { type: 'image/svg+xml' })
        : data;
      const objectUrl = URL.createObjectURL(blob);

      this.imgPreviewUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      this.modal.open();
    });
  }

  public submitForm() {
    const format = this.activeCategory.format;
    const name = _.isEmpty(this.product.productNames) ? this.product.name : _.get(_.first(this.product.productNames), 'value', '');
    const productName = this.replaceSpecialCharsWith_(name);
    const filename = `${this.product.gtin}_${productName}`;

    this.downloadBarCode(this.product.gtin, this.codeWidth, format, filename);
  }

  public replaceSpecialCharsWith_(filename: string) {
    return filename.replace(/[<>%:"'\/\\|?*\s]+/gi, '_');
  }
  private downloadBarCode(text, size, type, filename) {
    this.barcodeGenerationSvc.downloadBarCode(text, type, size).subscribe(async (data) => {
      const blob = typeof data === 'string'
        ? new Blob([data], { type: 'image/svg+xml' })
        : data;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.${type}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  }

}
